// GWP Promotion Block JavaScript
document.addEventListener('DOMContentLoaded', function() {
  
  // Helper function to reset button to original state
  function resetButton(button, originalText) {
    button.innerHTML = originalText;
    button.disabled = false;
    button.classList.remove('loading', 'success', 'error');
    button.style.color = '';
    button.style.textDecoration = '';
    button.style.backgroundColor = '';
  }
  
  // Handle GWP Add to Cart functionality
  function initGWPPromotions() {
    const gwpButtons = document.querySelectorAll('.gwp-add-btn:not([data-gwp-initialized])');
    
    gwpButtons.forEach(button => {
      // Mark as initialized to prevent duplicate listeners
      button.setAttribute('data-gwp-initialized', 'true');
      
      // Store original content on the button element itself
      button.setAttribute('data-original-text', button.innerHTML);
      
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Don't proceed if button is already processing
        if (this.disabled || this.classList.contains('loading')) {
          return;
        }
        
        const productId = this.getAttribute('data-product-id');
        const variantId = this.getAttribute('data-variant-id');
        
        if (!variantId) {
          console.error('GWP: No variant ID found');
          return;
        }
        
        // Get stored original text
        const originalText = this.getAttribute('data-original-text');
        
        // Update button state
        this.innerHTML = 'Adding...';
        this.disabled = true;
        this.classList.add('loading');
        
        // Add to cart
        addGWPToCart(variantId, originalText, this);
      });
    });
  }
  
  // Add GWP product to cart
  function addGWPToCart(variantId, originalText, button) {
    const formData = {
      'items': [{
        'id': variantId,
        'quantity': 1
      }]
    };
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      // Success - show brief success message
      button.innerHTML = '✓ Added!';
      button.classList.remove('loading');
      button.classList.add('success');
      
      // Reset button back to original state after 2 seconds
      setTimeout(() => {
        resetButton(button, originalText);
      }, 2000);
      
      // Update cart drawer/counter if available
      if (typeof window.updateCartDrawer === 'function') {
        window.updateCartDrawer();
      }
      
      // Try to update cart count if element exists
      const cartCount = document.querySelector('[data-cart-count]');
      if (cartCount) {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            cartCount.textContent = cart.item_count;
          })
          .catch(err => console.log('Cart count update failed:', err));
      }
      
      // Trigger cart update events
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { items: data.items }
      }));
      
      // Show success message if notification system exists
      if (typeof window.showNotification === 'function') {
        window.showNotification('Product added to bag!', 'success');
      }
      
      //console.log('GWP product added to cart:', data);
    })
    .catch(error => {
      //console.error('Error adding GWP to cart:', error);
      
      // Reset button on error
      button.innerHTML = 'Try Again';
      button.classList.remove('loading');
      button.classList.add('error');
      button.disabled = false;
      
      // Reset to original state after 3 seconds
      setTimeout(() => {
        resetButton(button, originalText);
      }, 3000);
      
      // Show error message if notification system exists
      if (typeof window.showNotification === 'function') {
        window.showNotification('Failed to add product. Please try again.', 'error');
      }
    });
  }
  
  // Initialize GWP promotions
  initGWPPromotions();
  
  // Re-initialize if new content is loaded dynamically
  document.addEventListener('shopify:section:load', initGWPPromotions);
  
  // Handle theme editor updates
  document.addEventListener('shopify:section:select', initGWPPromotions);
});